module.exports = __webpack_public_path__ + "static/media/train.814b1878.svg";